export default __webpack_public_path__ + "static/media/loading_order2.fea73516.gif";